import { useCallback, useEffect, useState } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import ModulesDashboard from '../../components/Modules/ModulesDashboard';
import ModulesService from '../../services/ModulesService';
import MediaService from '../../services/MediaService';

const Unit1Navigation = () => {
  const dispatch = useDispatch();
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);

  const [modulesConfig, setModulesConfig] = useState([]);

  const IMAGES_ENDPOINT = login.cloudFront + 'images';

  const WorldMap = `${IMAGES_ENDPOINT}/Images/Worlds/WorldMap_Large_Unit1_5of5.png${login.cookie}`;

  const getModulesConfiguration = useCallback(
    (modules) => {
      const mappedModules = modules
        .filter((module) => module.unit === 1)
        .map((module) => {
          let config = {};

          if (module.name === 'EyeContact') {
            config = ModulesService.getModuleConfig({
              currentModule: module,
              previousModule: null,
              totalDays: 9,
              bgImage: '/Module1Images/U1M1_Background_Landscape.png',
              destiny: '/eye-contact/navigation',
              title: 'Eye Contact',
              character: 'Crab',
              welcomeVideo: MediaService.getVideo('/Module1Videos/welcome.mp4', login),
              login,
            });
            dispatch({ type: 'SET_MODULE1_INITIALSTATE', payload: module });
          }

          if (module.name === 'Listening') {
            config = ModulesService.getModuleConfig({
              currentModule: module,
              previousModule: modules.find(
                (module) => module.name === 'EyeContact'
              ),
              totalDays: 9,
              bgImage: '/Module2Images/U1M2_DayScene_Landscape.png',
              destiny: '/listening/navigation',
              title: 'Listening',
              character: 'Dog',
              welcomeVideo: MediaService.getVideo('/Module2Videos/welcome.mp4', login),
              login,
            });
            dispatch({
              type: 'SET_MODULE2_INITIALSTATE',
              payload: module,
            });
          }

          if (module.name === 'Expressions') {
            config = ModulesService.getModuleConfig({
              currentModule: module,
              previousModule: modules.find(
                (module) => module.name === 'Listening'
              ),
              totalDays: 9,
              bgImage: '/Module3Images/U1M3_DayScene_Landscape.png',
              destiny: '/facial-expression/navigation',
              title: 'Facial Expressions',
              character: 'Lizard',
              welcomeVideo: MediaService.getVideo('/Module3Videos/welcome.mp4', login),
              login,
            });

            dispatch({
              type: 'SET_MODULE3_INITIALSTATE',
              payload: module,
            });
          }

          if (module.name === 'Posture') {
            config = ModulesService.getModuleConfig({
              currentModule: module,
              previousModule: modules.find(
                (module) => module.name === 'Expressions'
              ),
              totalDays: 9,
              bgImage: '/Module4Images/Background.png',
              destiny: '/posture/navigation',
              title: module.name,
              character: 'Monkey',
              welcomeVideo: '4658e34d06ec81ab1803590544bd/480.m3u8',
              login,
            });

            dispatch({
              type: 'SET_MODULE4_INITIALSTATE',
              payload: module,
            });
          }

          if (module.name === 'Distance') {
            config = ModulesService.getModuleConfig({
              currentModule: module,
              previousModule: modules.find(
                (module) => module.name === 'Posture'
              ),
              totalDays: 9,
              bgImage: '/Module5Images/Background.png',
              destiny: '/distance/navigation',
              title: module.name,
              character: 'Bird',
              welcomeVideo: MediaService.getVideo('/Module5Videos/welcome.mp4', login),
              login,
            });

            dispatch({
              type: 'SET_MODULE5_INITIALSTATE',
              payload: module,
            });
          }

          return {
            ...module,
            ...config,
          };
        });
      setModulesConfig(mappedModules);
    },
    [dispatch, login]
  );

  const getStudentModules = useCallback(async () => {
    const data = await ModulesService.getStudentModules(login.endPoint);
    getModulesConfiguration(data.modules);
  }, [getModulesConfiguration]);

  useEffect(() => {
    getStudentModules();
  }, [getStudentModules]);

  return (
    <ModulesDashboard
      modules={modulesConfig}
      pageTitle='Nonverbal Communication Skills'
      worldMapImage={WorldMap}
      world1={true}
      grade={login.grade}
      unit={1}
    />
  );
};
export default Unit1Navigation;
